<template>
    
      
        <UiNarrowContent>
          
            <!-- Title for the FAQ Section -->
            <h2 class="mb-4 mt-16 py-2">{{ tag }}</h2>
            
            <!-- New Section with Column Layout -->
            <div class="border-b border-black"> 
              <UiFaqItem v-for="(article, index) in articles" :article="article" :key="article.id"/>
            </div>
                                  
      </UiNarrowContent >
    
  
</template>
  

<script setup>
  const UiFaqItem = defineAsyncComponent(() => import('@/components/ui/FaqItem.vue'));
  
  
  // Props
  const props = defineProps({
    articles: {
      type: Array,
      required: true
    },
    tag: {
      type: String,
      required: false,
      default: null,
    }
    
  });
    
  </script>
  
  <style>
  .cursor-pointer {
    cursor: pointer;
  }

  .content-html ul {
  list-style-type: disc;
  margin-left: 1.5rem;
  padding-left: 1.5rem;
}

.content-html li {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.5;
}
  </style>
  